import { render, staticRenderFns } from "./PushUserResetPasswordHandler.vue?vue&type=template&id=2d2fc513&"
import script from "./PushUserResetPasswordHandler.vue?vue&type=script&lang=ts&"
export * from "./PushUserResetPasswordHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports